import React from 'react';

import Section from 'components/Section/Section';

import translationsJson from 'data/translations.json';

const translations: Translations = translationsJson;


interface Props {
    page: string;
    tab: string;
}

export default class Annotation extends React.Component<Props, {}> {
    private annotationSet = ["newborns_wordcloud", "newborns_ranking", "newborns_generationRanking", "firstnames_wordcloud", "firstnames_ranking", "lastnames_wordcloud", "lastnames_ranking"];

    render() {
        if(this.annotationSet.includes(this.props.page + "_" + this.props.tab)) {
            return (
                <Section>
                    <h4>{translations.annotationTitle[window.lang]}</h4>
                    <p style={{textAlign: "justify"}}>{translations.annotationText[window.lang]}</p>
                </Section>
            );
        }
        return (<></>);
    }
}